import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getNumberListApiCall = createAsyncThunk("numberList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: numberList } = await API.getNumberListApi(submitData);
         //console.log("*********************************************",numberList);
        dispatch(setLoader(false))
        return numberList;
    } catch (error) {
        throw error;
    }
});

export const editNumberDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editNumberData, code, message } = await API.updateNumberApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editNumberData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    numberList: {
        data: [],
        error: null,
    },
    editNumberData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const NumberSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNumberListApiCall.fulfilled, (state, action) => {
                state.numberList.data = action.payload;
            })
            .addCase(getNumberListApiCall.rejected, (state, action) => {
                state.numberList.error = action.error.message;
            })
            .addCase(editNumberDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editNumberData.data = data;
                state.editNumberData.message = message;
                state.editNumberData.code = code;
            })
            .addCase(editNumberDataApiCall.rejected, (state, action) => {
                state.editNumberData.error = action.error.message;
            });
    },
});

export default NumberSlice.reducer;